import React from 'react';
import OwlCarousel from 'react-owl-carousel';
const options = {
    margin: 10,
    responsiveClass: true,
    nav: true,
    dots: false,
    loop:true,
    autoplay: false,
    autoplayTimeout:5000,
    smartSpeed: 500,
    responsive: {
        0: {
            items: 2,
            margin: 10,
            nav: false,
            autoplay: true,
            autoplayTimeout:3000,
        },
        400: {
            items: 2,
            margin: 10,
            nav: false,
        },
        600: {
            items: 2,
            nav: false,
        },
        992: {
            items: 3,
        },
        1000: {
            items: 4,
 
        }
    },
 };
function Stats(){
    return <>
    <OwlCarousel className='owl-theme StatsOver' {...options}> 
        
    <div className='StatsWrap'>
            <div className='Content'>
                <img src={require('../../images/s1.webp')} alt=''/>
                <div className='TextBox'>
                    <p className='Number'>1234</p>
                    <p className='label'>Projects in total</p>
                </div>
            </div>
        </div>

        <div className='StatsWrap'>
            <div className='Content'>
                <img src={require('../../images/s2.webp')} alt=''/>
                <div className='TextBox'>
                    <p className='Number'>1234</p>
                    <p className='label'>Clients in total</p>
                </div>
            </div>
        </div>

        <div className='StatsWrap'>
            <div className='Content'>
                <img src={require('../../images/s3.webp')} alt=''/>
                <div className='TextBox'>
                    <p className='Number'>1234</p>
                    <p className='label'>Workinghours in total</p>
                </div>
            </div>
        </div>

        <div className='StatsWrap'>
            <div className='Content'>
                <img src={require('../../images/s4.webp')} alt=''/>
                <div className='TextBox'>
                    <p className='Number'>1234</p>
                    <p className='label'>Teammembers</p>
                </div>
            </div>
        </div>

        <div className='StatsWrap'>
            <div className='Content'>
                <img src={require('../../images/s2.webp')} alt=''/>
                <div className='TextBox'>
                    <p className='Number'>1234</p>
                    <p className='label'>Clients in total</p>
                </div>
            </div>
        </div>
    </OwlCarousel>
    </>
}
export default Stats;